var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.890137,
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_2672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7231 16.8901L19.1675 13.9945H16.3891V12.1154C16.3891 11.3233 16.7772 10.5511 18.0216 10.5511H19.2847V8.08576C19.2847 8.08576 18.1384 7.89014 17.0425 7.89014C14.7544 7.89014 13.2587 9.27701 13.2587 11.7876V13.9945H10.7153V16.8901H13.2587V23.8901H16.3891V16.8901H18.7231Z",
    fill: "#25282B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7.89014)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.8d23b554807c2acc860dd5c761fa4742.svg";
export { ForwardRef as ReactComponent };